<template>
    <rkm-row>
        <rkm-col cols="6">

            <rkm-form-input
                label="Nome"
                v-model="data.model.cidadao.nome"
                disabled
                uppercase
            />
        </rkm-col>

        <rkm-col cols="4">

            <rkm-form-input
                label="Nome social"
                v-model="data.model.cidadao.nomeSocial"
                disabled
                uppercase
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-input
                label="N° CPF"
                v-model="data.model.cidadao.cpf"
                v-mask="mask.cpf"
                disabled
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-input
                label="N° CNS"
                v-model="data.model.cidadao.cns"
                v-mask="mask.cns"
                disabled
            />
        </rkm-col>

        <rkm-col cols="2">

            <rkm-form-input
                label="Sexo"
                v-model="data.model.cidadao.sexo"
                disabled
                uppercase
            />
        </rkm-col>

        <rkm-col cols="2">

            <rkm-form-date-picker
                label="Data de nascimento"
                :max-date="data.form.dataAtual"
                v-model="data.model.cidadao.dataNascimento"
                disabled
                right
            />
        </rkm-col>

        <rkm-col cols="3">

            <rkm-form-input
                label="Idade"
                v-model="data.model.cidadao.idade"
                disabled
            />
        </rkm-col>

        <rkm-col cols="3">

            <rkm-form-input
                label="Escala de coelho"
                v-model="data.model.cidadao.escalaCoelho"
                disabled
            />
        </rkm-col>
    </rkm-row>
</template>

<script>

//Enums
import saidaCidadao from '@/enums/atencao-basica/saidaCidadao'
import nacionalidade from '@/enums/cadastro/cidadao/nacionalidade'

//Directives
import { VMoney } from 'v-money'

// Mixins
import { repository, object, data, mask } from '@/mixins'

export default {
    directives: { money: VMoney },
    computed: {
        validations() {

            return {
                responsavelFamiliar: {
                    required: true,
                },
                ativo: {
                    required: true,
                },
                profissao: {
                    min: 3,
                    max: 250,
                    termo_invalido: this.data.form.termosInvalidos,
                },
            }
        },
        isNaturalizadoBrasileiro() {

            return this.data.model.cidadao.nacionalidadeId == this.enums.nacionalidade.NATURALIZADO_BRASILEIRO
        },
    },
    created() {
        this.repositories.ocupacao = this.getConectaSusRepository('sigtap.ocupacao')
    },
    methods: {
        handleResponsavel() {

            if (this.data.model.cidadao.responsavel) {

                this.data.model.cidadao.responsavelCidadaoId = null
                this.data.model.informacao.parentescoResponsavelId = null
            }
        },
        handleOcupacaoResponsavel() {

            this.data.model.cidadao.ocupacao = null

            if (this.data.model.cidadao.responsavelCidadaoId !== null) {

                const cidadaoResponsavel = this.data.form.responsaveis.find(responsavel => responsavel.id === this.data.model.cidadao.responsavelCidadaoId);

                if (cidadaoResponsavel.ocupacaoId) {

                    this.data.model.cidadao.ocupacao = {
                        id: cidadaoResponsavel.ocupacaoId,
                        codigo: cidadaoResponsavel.ocupacaoCodigo,
                        nome: cidadaoResponsavel.ocupacaoNome,
                    };
                }
            }
        }
    },
    data: () => ({
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: false
        },
        enums: {
            saidaCidadao,
            nacionalidade
        },
        repositories: {},
        localForm: {
            autocompleteFields: {
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            },
        },
    }),
    mixins: [ repository, object, data, mask ],
    props: {
        data: { type: Object, required: false, },
    },
}
</script>

